import { PACKAGE_TYPES } from './package-types'
export const PACKAGE_NAME_MAP = {
    [PACKAGE_TYPES.BACKTESTING]: 'backtest',
    [PACKAGE_TYPES.PAPER_TRADING]: 'alert',
    [PACKAGE_TYPES.LIVE_TRADING]: 'live trading bot'
};
